$(document).ready(function() {
  $(".chosen-select").chosen({
    no_results_text: 'No results matched',
    width: '350px'
  });
  $(".chosen-choices").click(function(){
    $(this).parent().find(".chosen-drop").toggle();
  });
});
